"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Counter = exports.CounterSize = void 0;
var React = require("react");
var classnames_1 = require("classnames");
var input_1 = require("wix-ui-core/dist/src/components/input");
var button_1 = require("wix-ui-core/dist/src/components/deprecated/button");
var Counter_st_css_1 = require("./Counter.st.css");
var Error_1 = require("wix-ui-icons-common/on-stage/Error");
var ErrorSmall_1 = require("wix-ui-icons-common/on-stage/ErrorSmall");
var Plus_1 = require("wix-ui-icons-common/on-stage/Plus");
var Minus_1 = require("wix-ui-icons-common/on-stage/Minus");
var dataKeys_1 = require("./dataKeys");
var IconTooltip_1 = require("../IconTooltip");
var TooltipEnums_1 = require("../Tooltip/TooltipEnums");
var uniqueId = require('lodash/uniqueId');
var CounterSize;
(function (CounterSize) {
    CounterSize["medium"] = "medium";
    CounterSize["xSmall"] = "xSmall";
})(CounterSize = exports.CounterSize || (exports.CounterSize = {}));
/** Counter */
var Counter = /** @class */ (function (_super) {
    __extends(Counter, _super);
    function Counter(props) {
        var _this = _super.call(this, props) || this;
        _this._rootRef = React.createRef();
        _this._inputRef = React.createRef();
        _this.state = {
            isErrorTooltipShown: false,
            focused: false,
            errorIconClicked: false,
            isWithinRoot: false,
        };
        _this.showErrorTooltip = function () {
            _this._toggleTooltip(true);
        };
        _this.hideErrorTooltip = function () {
            _this._toggleTooltip(false);
        };
        _this._onDecrement = function () {
            var _a = _this.props, step = _a.step, max = _a.max, onChange = _a.onChange, value = _a.value;
            if (max || max === 0) {
                var result = Math.min(max, value - step);
                onChange(result.toString());
                return;
            }
            onChange((value - step).toString());
        };
        _this._onIncrement = function () {
            var _a = _this.props, step = _a.step, min = _a.min, onChange = _a.onChange, value = _a.value;
            if (min || min === 0) {
                var result = Math.max(min, value + step);
                onChange(result.toString());
                return;
            }
            onChange((value + step).toString());
        };
        _this._onRootFocus = function () {
            var _a = _this.state, isWithinRoot = _a.isWithinRoot, errorIconClicked = _a.errorIconClicked;
            if (!isWithinRoot && !errorIconClicked) {
                _this.setState({ isWithinRoot: true });
                _this._toggleTooltip(true);
            }
        };
        _this._toggleTooltip = function (showTooltip) {
            _this.setState({ isErrorTooltipShown: showTooltip });
        };
        _this._onErrorIconMouseDown = function () {
            _this.setState({ errorIconClicked: true });
        };
        _this._onErrorIconClick = function () {
            var isErrorTooltipShown = _this.state.isErrorTooltipShown;
            _this._toggleTooltip(!isErrorTooltipShown);
            _this.setState({ errorIconClicked: false });
        };
        _this._onErrorIconKeyDown = function (e) {
            if (!e.shiftKey && e.key === 'Tab') {
                // The ErrorIcon is at the edge of the component - Tab click exits the Component
                _this._exitComponent();
                _this.setState({ focused: false });
            }
        };
        _this._onPlusKeyDown = function (e) {
            if (e.shiftKey && e.key === 'Tab') {
                // The Plus Button is at the edge of the component - Shift Tab click exits the Component
                _this._exitComponent();
            }
        };
        _this._exitComponent = function () {
            _this._toggleTooltip(false);
            _this.setState({ isWithinRoot: false });
        };
        _this._onFocus = function () {
            _this.setState({ focused: true });
        };
        _this._onBlur = function () {
            _this.setState({ focused: false });
        };
        _this._onClickOutside = function () {
            if (_this._rootRef.current &&
                !_this._rootRef.current.contains(document.activeElement)) {
                _this._exitComponent();
            }
        };
        _this._getErrorIcon = function () {
            var size = _this.props.size;
            var ErrorIcon = size === 'medium' ? Error_1.default : ErrorSmall_1.default;
            return React.createElement(ErrorIcon, { className: Counter_st_css_1.classes.error });
        };
        _this._dataAttrs = function () {
            var _a;
            var _b = _this.props, disabled = _b.disabled, error = _b.error;
            return _a = {},
                _a[dataKeys_1.DATA_ATTRS.DISABLED] = disabled,
                _a[dataKeys_1.DATA_ATTRS.ERROR] = error,
                _a;
        };
        _this._errorMessageId = uniqueId('error-message');
        return _this;
    }
    Counter.prototype.render = function () {
        var _a;
        var _b = this.props, incrementAriaLabel = _b.incrementAriaLabel, decrementAriaLabel = _b.decrementAriaLabel, inputAriaLabel = _b.inputAriaLabel, min = _b.min, max = _b.max, step = _b.step, disabled = _b.disabled, onChange = _b.onChange, value = _b.value, error = _b.error, errorMessage = _b.errorMessage, className = _b.className, size = _b.size, ariaDescribedBy = _b["aria-describedby"], errorTooltipPlacement = _b.errorTooltipPlacement, errorTooltipMaxWidth = _b.errorTooltipMaxWidth;
        var shouldShowErrorMessageTooltip = error && !!errorMessage;
        var icon = this._getErrorIcon();
        var isErrorTooltipShown = this.state.isErrorTooltipShown;
        return (React.createElement("div", __assign({ className: Counter_st_css_1.st(Counter_st_css_1.classes.root, { disabled: disabled, error: error }, classnames_1.default(className, (_a = {},
                _a[Counter_st_css_1.classes.xSmall] = size === CounterSize.xSmall,
                _a))), dir: "ltr", role: "region", "aria-labelledby": this.props['aria-labelledby'], "aria-label": this.props['aria-label'], "data-hook": this.props['data-hook'] }, this._dataAttrs(), { onFocus: this._onRootFocus, ref: this._rootRef }),
            React.createElement(button_1.Button, { "aria-label": incrementAriaLabel, className: Counter_st_css_1.st(Counter_st_css_1.classes.btn, Counter_st_css_1.classes.plus), "data-hook": dataKeys_1.DATA_HOOKS.PLUS_BUTTON, onClick: this._onIncrement, onKeyDown: this._onPlusKeyDown, name: "increment", disabled: disabled || (max && value + step > max) },
                React.createElement(Plus_1.default, { className: Counter_st_css_1.classes.btnIcon })),
            React.createElement("div", { className: Counter_st_css_1.classes.inputWrapper },
                React.createElement(input_1.Input, { "aria-label": inputAriaLabel, "aria-live": "assertive", "aria-describedby": ((ariaDescribedBy || '') + " " + (errorMessage ? this._errorMessageId : '')).trim(), onChange: function (ev) { return onChange(ev.target.value); }, onFocus: this._onFocus, onBlur: this._onBlur, type: "number", ref: this._inputRef, disabled: disabled, min: min, max: max, step: step, error: error, value: value.toString() })),
            React.createElement(button_1.Button, { "aria-label": decrementAriaLabel, className: Counter_st_css_1.st(Counter_st_css_1.classes.btn, Counter_st_css_1.classes.minus), "data-hook": dataKeys_1.DATA_HOOKS.MINUS_BUTTON, onClick: this._onDecrement, name: "decrement", disabled: disabled || value - step < min },
                React.createElement(Minus_1.default, { className: Counter_st_css_1.classes.btnIcon })),
            shouldShowErrorMessageTooltip && (React.createElement(IconTooltip_1.IconTooltip, { "data-hook": dataKeys_1.DATA_HOOKS.ERROR_TOOLTIP_ICON, message: errorMessage, icon: icon, tooltipId: this._errorMessageId, tooltipSkin: TooltipEnums_1.TooltipSkin.Error, showTooltip: isErrorTooltipShown, onMouseDown: this._onErrorIconMouseDown, onClick: this._onErrorIconClick, onClickOutside: this._onClickOutside, onKeyDown: this._onErrorIconKeyDown, className: Counter_st_css_1.classes.errorIcon, tooltipProps: {
                    placement: errorTooltipPlacement,
                    maxWidth: errorTooltipMaxWidth,
                    appendTo: 'window',
                } }))));
    };
    Counter.displayName = 'Counter';
    Counter.defaultProps = {
        step: 1,
        value: 0,
        size: CounterSize.medium,
        errorTooltipPlacement: 'top',
    };
    return Counter;
}(React.Component));
exports.Counter = Counter;
//# sourceMappingURL=Counter.js.map